import React from "react";
import { Pin } from "./icons";

export const Zones = ({ data }) => {
  if (!data) return null;

  return (
    <section id="zones" className="section zones">
      <div className="container">
        <h2 className="section-title">{data.title}</h2>
        <p className="section-lead">{data.intro}</p>

        <div className="zones-grid">
          {data.departments.map((d) => (
            <article className="zone-card" key={d.code}>
              <span className="zone-code">{d.code}</span>
              <div>
                <h3>{d.name}</h3>
                <p>{d.cities}</p>
              </div>
            </article>
          ))}
        </div>

        <p className="zones-note">
          <Pin size={16} />
          Longue distance au départ de l'Île-de-France vers toute la France et l'Europe —
          Belgique, Luxembourg, Allemagne, Suisse, Italie, Espagne, Pays-Bas.
        </p>
      </div>
    </section>
  );
};

export default Zones;
